const ZoominfoPersonRecordOpenCaret = function(props) {
  var class_name = props.open ? "rspec_toggle_revealed_by fa fa-chevron-up action_link" : "rspec_toggle_revealed_by fa fa-chevron-down action_link";
  return (
    <td width="20px" onClick={props.handleClick}>
      <i className={class_name} />
    </td>
  );
}

export default ZoominfoPersonRecordOpenCaret